
      import Template7 from 'template7';
      const Template7Helpers = Template7.helpers;
  
      
  
      export default {
  data() {
    return {
      lng: lng,
      list: [],
      detail: {
        poi: {
          images: []
        },
        params: {}
      },
      me: myApp.user,
      vote: {}
    };
  },

  mounted() {
    this.load();
  },

  methods: {
    stars(type, n) {
      for (let i = 1; i <= 5; i++) {
        if (i <= n) {
          this.$('.' + type + '-' + i).html('<i class="f7-icons">star_fill</i>');
        } else {
          this.$('.' + type + '-' + i).html('<i class="f7-icons">star</i>');
        }
      }

      this.vote[type] = n;
    },

    saveReview() {
      const self = this,
            $ = this.$,
            app = this.$app;

      if (!this.vote.general) {
        return app.dialog.alert(lng.reviewError1);
      }

      this.vote.title = this.$('#review-title').val();
      this.vote.comment = this.$('#review-comment').val();
      this.vote.idpoi = this.detail.poi.id;
      myApp.server.post('imc/review', self.vote).then(succ => {
        app.popup.close();
      }).catch(err => {
        console.log(err);
        app.toast.show({
          text: lng.errorTryLater,
          closeTimeout: 3000,
          cssClass: 'bg-color-red',
          position: 'bottom'
        });
      });
    },

    view(id) {
      const self = this,
            app = this.$app;
      this.list.forEach(a => {
        if (a.id === id) {
          this.vote = {
            id: id
          };

          if (a.poi.reviews) {
            for (let i = 0; i < a.poi.reviews.length; i++) {
              //console.log(a.poi.reviews[i].id, id);
              if (a.poi.reviews[i].id == id) {
                self.vote = a.poi.reviews[i];
                self.vote.general = self.vote.stars;
              }
            }
          }

          const popup = self.$app.popup.create({
            el: '.popup-detail',
            swipeToClose: true
          });
          popup.open();
          self.$setState({
            detail: a
          }, () => {
            app.swiper.destroy('.booking-confirm-swiper');
            app.swiper.create({
              el: '.booking-confirm-swiper'
            });
            app.fab.open('.booking-fab');
          }); //console.log(self.vote);

          return;
        }
      });
    },

    cancel(id) {
      const self = this,
            app = this.$app,
            $ = this.$;
      app.dialog.confirm(lng.cancelBookingMessage, () => {
        app.preloader.show();
        myApp.server.delete('imc/booking/' + id).then(succ => {
          app.dialog.alert(lng.cancelBookingOk, () => {
            app.popup.close();
            self.load();
          });
        }).catch(err => {
          console.log(err);
          app.toast.show({
            text: lng.errorTryLater,
            closeTimeout: 3000,
            cssClass: 'bg-color-red',
            position: 'bottom'
          });
        }).finally(() => app.preloader.hide());
      });
    },

    edit(id) {
      const d = new Date(this.detail.ts * 1000);
      this.$app.popup.open('.popup-edit');
      this.$app.calendar.destroy('#booking_edit_datetime');
      const now = new Date();
      myApp.bookingEditCalendar = this.$app.calendar.create({
        inputEl: '#booking_edit_datetime',
        timePicker: true,
        dateFormat: "yyyy-mm-ddTHH::mm:ss",
        value: [d],
        minDate: new Date(now.getFullYear(), now.getMonth(), now.getDate(), 0, 0, 0),
        on: {
          'change': function (a, b) {
            console.log(a, b); //a.close();
          }
        }
      });
    },

    editSave() {
      const $ = this.$,
            self = this;
      myApp.server.put('imc/booking/' + this.detail.id, {
        datetime: myApp.bookingEditCalendar.value[0],
        diners: $('#booking_edit_diners').val(),
        notes: $('#booking_edit_notes').val()
      }).then(succ => {
        let list = self.list;

        for (let i in list) {
          if (list[i].id == succ.id) {
            list[i] = succ;
            break;
          }
        }

        self.$setState({
          list: list,
          detail: succ
        });
        self.$app.popup.close('.popup-edit');
      }).catch(err => {
        console.log(err);
        self.$app.toast.show({
          text: lng.errorTryLater,
          closeTimeout: 3000,
          cssClass: 'bg-color-red',
          position: 'bottom'
        });
      });
    },

    writeReview(id) {
      this.$app.popup.open('.popup-write-review');
    },

    load() {
      const self = this;
      myApp.server.get('imc/booking').then(succ => {
        self.$setState({
          list: succ
        });
      }).catch(err => {
        console.log(err);
      });
    }

  },
  id: '6c2d255b1c',

  render() {
    return function (ctx_1, data_1, root) {
      function isArray(arr) {
        return Array.isArray(arr);
      }

      function isFunction(func) {
        return typeof func === 'function';
      }

      function c(val, ctx) {
        if (typeof val !== "undefined" && val !== null) {
          if (isFunction(val)) {
            return val.call(ctx);
          } else return val;
        } else return "";
      }

      root = root || ctx_1 || {};
      var r = '';
      r += '\n  <div class="page">\n    <div class="navbar">\n      <div class="navbar-bg"></div>\n      <div class="navbar-inner sliding">\n        <div class="left">\n          <a href="#" class="link back">\n            <i class="icon icon-back"></i>\n            <span class="if-not-md">Back</span>\n          </a>\n        </div>\n        <div class="title">';
      r += c(ctx_1.lng.activeBookings, ctx_1);
      r += '</div>\n      </div>\n    </div>\n    <div class="page-content">\n      <div class="list media-list chevron-center no-hairline" style="margin-top: 0">\n        <ul>\n          ';
      r += Template7Helpers.each.call(ctx_1, ctx_1.list, {
        hash: {},
        data: data_1 || {},
        fn: function (ctx_2, data_2) {
          var r = '';
          r += '\n          <li>\n            <a href="#" @click="view(\'';
          r += c(ctx_2.id, ctx_2);
          r += '\')" class="item-link item-content">\n              <div class="item-media">\n                ';
          r += Template7Helpers.if.call(ctx_2, ctx_2.poi.images[0], {
            hash: {},
            data: data_2 || {},
            fn: function (ctx_3, data_3) {
              var r = '';
              r += '\n                <div class="booking-media" style="background-image: url(';
              r += c(ctx_3.poi.images[0].url, ctx_3);
              r += ')"></div>\n                ';
              return r;
            },
            inverse: function (ctx_3, data_3) {
              var r = '';
              r += '\n                <div class="booking-media" style="background-image: url(static/';
              r += c(ctx_3.poi.type, ctx_3);
              r += '.png)"></div>\n                ';
              return r;
            },
            root: root,
            parents: [ctx_1]
          });
          r += '\n              </div>\n              <div class="item-inner">\n                <div class="item-title-row">\n                  <div class="item-title">\n                    <span class="booking-status booking-status-';
          r += c(ctx_2.status, ctx_2);
          r += ' ';
          r += c(ctx_2.expired, ctx_2);
          r += '"></span>\n                    <span style="font-weight: 300; font-size: 12px">\n                      ';
          r += Template7Helpers.js.call(ctx_2, "lng.booking_status[this.status]", {
            hash: {},
            data: data_2 || {},
            fn: function empty() {
              return '';
            },
            inverse: function empty() {
              return '';
            },
            root: root,
            parents: [ctx_1]
          });
          r += '\n                    </span>\n                  </div>\n                  <div class="item-after">';
          r += Template7Helpers.js.call(ctx_2, "new Date(this.ts * 1000).toLocaleString()", {
            hash: {},
            data: data_2 || {},
            fn: function empty() {
              return '';
            },
            inverse: function empty() {
              return '';
            },
            root: root,
            parents: [ctx_1]
          });
          r += '</div>\n                </div>\n                <div class="item-subtitle">';
          r += c(ctx_2.poi.caption, ctx_2);
          r += '</div>\n                <div class="item-text">\n                  ';
          r += c(root.lng.diners, ctx_2);
          r += ': ';
          r += c(ctx_2.diners, ctx_2);
          r += ' <br>\n                  ';
          r += c(ctx_2.notes, ctx_2);
          r += '\n                </div>\n              </div>\n            </a>\n          </li>\n          ';
          return r;
        },
        inverse: function empty() {
          return '';
        },
        root: root,
        parents: [ctx_1]
      });
      r += '\n        </ul>\n      </div>\n      ';
      r += Template7Helpers.js_if.call(ctx_1, "this.list.length == 0", {
        hash: {},
        data: data_1 || {},
        fn: function (ctx_2, data_2) {
          var r = '';
          r += '\n      <div class=\'text-align-center block\'>\n        <img width="50%" src="static/notfound.svg" alt=""/>\n        <h3>';
          r += c(ctx_2.lng.noReservations, ctx_2);
          r += '</h3>\n      </div>\n      ';
          return r;
        },
        inverse: function empty() {
          return '';
        },
        root: root,
        parents: [ctx_1]
      });
      r += '\n    </div>\n\n    <div class="popup popup-detail popup-tablet-fullscreen" data-swipe-to-close="true">\n      <div class="view">\n        <div class="page">\n          <div class="navbar bg-color-imc">\n            <div class="navbar-bg bg-color-imc"></div>\n            <div class="navbar-inner bg-color-imc">\n              <div class="title center sliding text-uppercase">ID: ';
      r += c(ctx_1.detail.id, ctx_1);
      r += '</div>\n              <div class="right">\n                <a class="link popup-close">\n                  <i class="icon f7-icons text-color-primary">multiply_circle_fill</i>\n                </a>\n              </div>\n            </div>\n          </div>\n          <div class="page-content">\n            <div class="swiper-container booking-confirm-swiper">\n              <div class="swiper-wrapper">\n                ';
      r += Template7Helpers.each.call(ctx_1, ctx_1.detail.poi.images, {
        hash: {},
        data: data_1 || {},
        fn: function (ctx_2, data_2) {
          var r = '';
          r += '\n                <div class="swiper-slide"><div class="slide-bg h-33" style="background-image: url(';
          r += c(ctx_2.url, ctx_2);
          r += ')"></div></div>\n                ';
          return r;
        },
        inverse: function (ctx_2, data_2) {
          var r = '';
          r += '\n                <div class="swiper-slide"><div class="slide-bg h-33" style="background-image: url(';
          r += c(ctx_1.type, ctx_2);
          r += ')"></div></div>\n                ';
          return r;
        },
        root: root,
        parents: [ctx_1]
      });
      r += '\n              </div>\n              <div class="slide-bg-title">';
      r += c(ctx_1.detail.poi.caption, ctx_1);
      r += '</div>\n            </div>\n\n            <div class="block" style="margin-top: 20px">\n              <div class="booking-confirm-item">\n                <img width="32" src="static/Cliente.png" alt=""/>\n                <span class="title">';
      r += c(ctx_1.lng.client, ctx_1);
      r += '</span>\n                ';
      r += c(root.me.client_code, ctx_1);
      r += '\n              </div>\n              <div class="booking-confirm-item">\n                <img width="32" src="static/DataOra.png" alt=""/>\n                <span class="title">';
      r += c(ctx_1.lng.dateAndTime, ctx_1);
      r += ':</span>\n                ';
      r += Template7Helpers.js.call(ctx_1, "new Date(this.detail.ts*1000).toLocaleString()", {
        hash: {},
        data: data_1 || {},
        fn: function empty() {
          return '';
        },
        inverse: function empty() {
          return '';
        },
        root: root,
        parents: [ctx_1]
      });
      r += '\n              </div>\n              <div class="booking-confirm-item">\n                <img width="32" src="static/Coperti.png" alt=""/>\n                <span class="title">';
      r += c(ctx_1.lng.diners, ctx_1);
      r += ':</span>\n                ';
      r += c(ctx_1.detail.diners, ctx_1);
      r += '\n              </div>\n              <div class="booking-confirm-item">\n                <div class="col-auto">\n                  <img width="32" src="static/Note.png" alt=""/>\n                </div>\n                <div class="col-auto pl-1">\n                  <span class="title">';
      r += c(ctx_1.lng.notes, ctx_1);
      r += ':</span>\n                </div>\n                <div class="col-auto pl-1">\n                  ';
      r += c(ctx_1.detail.notes, ctx_1);
      r += '\n                </div>\n              </div>\n              <div class="booking-confirm-item">\n                <i class="f7-icons icon-rounded bg-color-deeppurple text-color-white">star_fill</i>\n                <span class="title">';
      r += c(ctx_1.lng.promoCode, ctx_1);
      r += ':</span>\n                ';
      r += c(ctx_1.detail.promo_code, ctx_1);
      r += '\n              </div>\n              <div class="booking-confirm-item">\n                <img width="32" src="static/Costo.png" alt=""/>\n                <span class="title">';
      r += c(ctx_1.lng.booking, ctx_1);
      r += ':</span>\n                <span class="text-uppercase">';
      r += c(ctx_1.detail.params.booking_price_cur, ctx_1);
      r += '</span> ';
      r += c(ctx_1.detail.total_price, ctx_1);
      r += '\n              </div>\n\n              <h4 class="text-align-center text-uppercase">\n                <span class="booking-status booking-status-';
      r += c(ctx_1.detail.status, ctx_1);
      r += '"></span>\n                ';
      r += Template7Helpers.js.call(ctx_1, "lng.booking_status[this.detail.status]", {
        hash: {},
        data: data_1 || {},
        fn: function empty() {
          return '';
        },
        inverse: function empty() {
          return '';
        },
        root: root,
        parents: [ctx_1]
      });
      r += '\n              </h4>\n\n              ';
      r += Template7Helpers.each.call(ctx_1, ctx_1.detail.poi.reviews, {
        hash: {},
        data: data_1 || {},
        fn: function (ctx_2, data_2) {
          var r = '';
          r += '\n              ';
          r += Template7Helpers.js_if.call(ctx_2, "this.iduser == myApp.user.id", {
            hash: {},
            data: data_2 || {},
            fn: function (ctx_3, data_3) {
              var r = '';
              r += '\n              <hr>\n              <h4>';
              r += c(root.lng.nyReviewOf, ctx_3);
              r += ' ';
              r += Template7Helpers.js.call(ctx_3, "new Date(this.ts * 1000).toLocaleString()", {
                hash: {},
                data: data_3 || {},
                fn: function empty() {
                  return '';
                },
                inverse: function empty() {
                  return '';
                },
                root: root,
                parents: [ctx_2, ctx_1]
              });
              r += ' </h4>\n\n              <div class="margin-bottom">\n                <i class="icon icon-small f7-icons text-color-primary">star';
              r += Template7Helpers.js_if.call(ctx_3, "this.stars > 0", {
                hash: {},
                data: data_3 || {},
                fn: function (ctx_4, data_4) {
                  var r = '';
                  r += '_fill';
                  return r;
                },
                inverse: function empty() {
                  return '';
                },
                root: root,
                parents: [ctx_2, ctx_1]
              });
              r += '</i>\n                <i class="icon icon-small f7-icons text-color-primary">star';
              r += Template7Helpers.js_if.call(ctx_3, "this.stars > 1", {
                hash: {},
                data: data_3 || {},
                fn: function (ctx_4, data_4) {
                  var r = '';
                  r += '_fill';
                  return r;
                },
                inverse: function empty() {
                  return '';
                },
                root: root,
                parents: [ctx_2, ctx_1]
              });
              r += '</i>\n                <i class="icon icon-small f7-icons text-color-primary">star';
              r += Template7Helpers.js_if.call(ctx_3, "this.stars > 2", {
                hash: {},
                data: data_3 || {},
                fn: function (ctx_4, data_4) {
                  var r = '';
                  r += '_fill';
                  return r;
                },
                inverse: function empty() {
                  return '';
                },
                root: root,
                parents: [ctx_2, ctx_1]
              });
              r += '</i>\n                <i class="icon icon-small f7-icons text-color-primary">star';
              r += Template7Helpers.js_if.call(ctx_3, "this.stars > 3", {
                hash: {},
                data: data_3 || {},
                fn: function (ctx_4, data_4) {
                  var r = '';
                  r += '_fill';
                  return r;
                },
                inverse: function empty() {
                  return '';
                },
                root: root,
                parents: [ctx_2, ctx_1]
              });
              r += '</i>\n                <i class="icon icon-small f7-icons text-color-primary">star';
              r += Template7Helpers.js_if.call(ctx_3, "this.stars > 4", {
                hash: {},
                data: data_3 || {},
                fn: function (ctx_4, data_4) {
                  var r = '';
                  r += '_fill';
                  return r;
                },
                inverse: function empty() {
                  return '';
                },
                root: root,
                parents: [ctx_2, ctx_1]
              });
              r += '</i>\n              </div>\n              <div>\n                Location\n                <i class="icon icon-xs f7-icons text-color-primary">star';
              r += Template7Helpers.js_if.call(ctx_3, "this.stars_location > 0", {
                hash: {},
                data: data_3 || {},
                fn: function (ctx_4, data_4) {
                  var r = '';
                  r += '_fill';
                  return r;
                },
                inverse: function empty() {
                  return '';
                },
                root: root,
                parents: [ctx_2, ctx_1]
              });
              r += '</i>\n                <i class="icon icon-xs f7-icons text-color-primary">star';
              r += Template7Helpers.js_if.call(ctx_3, "this.stars_location > 1", {
                hash: {},
                data: data_3 || {},
                fn: function (ctx_4, data_4) {
                  var r = '';
                  r += '_fill';
                  return r;
                },
                inverse: function empty() {
                  return '';
                },
                root: root,
                parents: [ctx_2, ctx_1]
              });
              r += '</i>\n                <i class="icon icon-xs f7-icons text-color-primary">star';
              r += Template7Helpers.js_if.call(ctx_3, "this.stars_location > 2", {
                hash: {},
                data: data_3 || {},
                fn: function (ctx_4, data_4) {
                  var r = '';
                  r += '_fill';
                  return r;
                },
                inverse: function empty() {
                  return '';
                },
                root: root,
                parents: [ctx_2, ctx_1]
              });
              r += '</i>\n                <i class="icon icon-xs f7-icons text-color-primary">star';
              r += Template7Helpers.js_if.call(ctx_3, "this.stars_location > 3", {
                hash: {},
                data: data_3 || {},
                fn: function (ctx_4, data_4) {
                  var r = '';
                  r += '_fill';
                  return r;
                },
                inverse: function empty() {
                  return '';
                },
                root: root,
                parents: [ctx_2, ctx_1]
              });
              r += '</i>\n                <i class="icon icon-xs f7-icons text-color-primary">star';
              r += Template7Helpers.js_if.call(ctx_3, "this.stars_location > 4", {
                hash: {},
                data: data_3 || {},
                fn: function (ctx_4, data_4) {
                  var r = '';
                  r += '_fill';
                  return r;
                },
                inverse: function empty() {
                  return '';
                },
                root: root,
                parents: [ctx_2, ctx_1]
              });
              r += '</i>\n              </div>\n              <div>\n                Service\n                <i class="icon icon-xs f7-icons text-color-primary">star';
              r += Template7Helpers.js_if.call(ctx_3, "this.stars_service > 0", {
                hash: {},
                data: data_3 || {},
                fn: function (ctx_4, data_4) {
                  var r = '';
                  r += '_fill';
                  return r;
                },
                inverse: function empty() {
                  return '';
                },
                root: root,
                parents: [ctx_2, ctx_1]
              });
              r += '</i>\n                <i class="icon icon-xs f7-icons text-color-primary">star';
              r += Template7Helpers.js_if.call(ctx_3, "this.stars_service > 1", {
                hash: {},
                data: data_3 || {},
                fn: function (ctx_4, data_4) {
                  var r = '';
                  r += '_fill';
                  return r;
                },
                inverse: function empty() {
                  return '';
                },
                root: root,
                parents: [ctx_2, ctx_1]
              });
              r += '</i>\n                <i class="icon icon-xs f7-icons text-color-primary">star';
              r += Template7Helpers.js_if.call(ctx_3, "this.stars_service > 2", {
                hash: {},
                data: data_3 || {},
                fn: function (ctx_4, data_4) {
                  var r = '';
                  r += '_fill';
                  return r;
                },
                inverse: function empty() {
                  return '';
                },
                root: root,
                parents: [ctx_2, ctx_1]
              });
              r += '</i>\n                <i class="icon icon-xs f7-icons text-color-primary">star';
              r += Template7Helpers.js_if.call(ctx_3, "this.stars_service > 3", {
                hash: {},
                data: data_3 || {},
                fn: function (ctx_4, data_4) {
                  var r = '';
                  r += '_fill';
                  return r;
                },
                inverse: function empty() {
                  return '';
                },
                root: root,
                parents: [ctx_2, ctx_1]
              });
              r += '</i>\n                <i class="icon icon-xs f7-icons text-color-primary">star';
              r += Template7Helpers.js_if.call(ctx_3, "this.stars_service > 4", {
                hash: {},
                data: data_3 || {},
                fn: function (ctx_4, data_4) {
                  var r = '';
                  r += '_fill';
                  return r;
                },
                inverse: function empty() {
                  return '';
                },
                root: root,
                parents: [ctx_2, ctx_1]
              });
              r += '</i>\n              </div>\n              <div>\n                Menu / Performance\n                <i class="icon icon-xs f7-icons text-color-primary">star';
              r += Template7Helpers.js_if.call(ctx_3, "this.stars_menu > 0", {
                hash: {},
                data: data_3 || {},
                fn: function (ctx_4, data_4) {
                  var r = '';
                  r += '_fill';
                  return r;
                },
                inverse: function empty() {
                  return '';
                },
                root: root,
                parents: [ctx_2, ctx_1]
              });
              r += '</i>\n                <i class="icon icon-xs f7-icons text-color-primary">star';
              r += Template7Helpers.js_if.call(ctx_3, "this.stars_menu > 1", {
                hash: {},
                data: data_3 || {},
                fn: function (ctx_4, data_4) {
                  var r = '';
                  r += '_fill';
                  return r;
                },
                inverse: function empty() {
                  return '';
                },
                root: root,
                parents: [ctx_2, ctx_1]
              });
              r += '</i>\n                <i class="icon icon-xs f7-icons text-color-primary">star';
              r += Template7Helpers.js_if.call(ctx_3, "this.stars_menu > 2", {
                hash: {},
                data: data_3 || {},
                fn: function (ctx_4, data_4) {
                  var r = '';
                  r += '_fill';
                  return r;
                },
                inverse: function empty() {
                  return '';
                },
                root: root,
                parents: [ctx_2, ctx_1]
              });
              r += '</i>\n                <i class="icon icon-xs f7-icons text-color-primary">star';
              r += Template7Helpers.js_if.call(ctx_3, "this.stars_menu > 3", {
                hash: {},
                data: data_3 || {},
                fn: function (ctx_4, data_4) {
                  var r = '';
                  r += '_fill';
                  return r;
                },
                inverse: function empty() {
                  return '';
                },
                root: root,
                parents: [ctx_2, ctx_1]
              });
              r += '</i>\n                <i class="icon icon-xs f7-icons text-color-primary">star';
              r += Template7Helpers.js_if.call(ctx_3, "this.stars_menu > 4", {
                hash: {},
                data: data_3 || {},
                fn: function (ctx_4, data_4) {
                  var r = '';
                  r += '_fill';
                  return r;
                },
                inverse: function empty() {
                  return '';
                },
                root: root,
                parents: [ctx_2, ctx_1]
              });
              r += '</i>\n              </div>\n              <div>\n                ';
              r += c(root.lng.price, ctx_3);
              r += '\n                <i class="icon icon-xs f7-icons text-color-primary">star';
              r += Template7Helpers.js_if.call(ctx_3, "this.stars_price > 0", {
                hash: {},
                data: data_3 || {},
                fn: function (ctx_4, data_4) {
                  var r = '';
                  r += '_fill';
                  return r;
                },
                inverse: function empty() {
                  return '';
                },
                root: root,
                parents: [ctx_2, ctx_1]
              });
              r += '</i>\n                <i class="icon icon-xs f7-icons text-color-primary">star';
              r += Template7Helpers.js_if.call(ctx_3, "this.stars_price > 1", {
                hash: {},
                data: data_3 || {},
                fn: function (ctx_4, data_4) {
                  var r = '';
                  r += '_fill';
                  return r;
                },
                inverse: function empty() {
                  return '';
                },
                root: root,
                parents: [ctx_2, ctx_1]
              });
              r += '</i>\n                <i class="icon icon-xs f7-icons text-color-primary">star';
              r += Template7Helpers.js_if.call(ctx_3, "this.stars_price > 2", {
                hash: {},
                data: data_3 || {},
                fn: function (ctx_4, data_4) {
                  var r = '';
                  r += '_fill';
                  return r;
                },
                inverse: function empty() {
                  return '';
                },
                root: root,
                parents: [ctx_2, ctx_1]
              });
              r += '</i>\n                <i class="icon icon-xs f7-icons text-color-primary">star';
              r += Template7Helpers.js_if.call(ctx_3, "this.stars_price > 3", {
                hash: {},
                data: data_3 || {},
                fn: function (ctx_4, data_4) {
                  var r = '';
                  r += '_fill';
                  return r;
                },
                inverse: function empty() {
                  return '';
                },
                root: root,
                parents: [ctx_2, ctx_1]
              });
              r += '</i>\n                <i class="icon icon-xs f7-icons text-color-primary">star';
              r += Template7Helpers.js_if.call(ctx_3, "this.stars_price > 4", {
                hash: {},
                data: data_3 || {},
                fn: function (ctx_4, data_4) {
                  var r = '';
                  r += '_fill';
                  return r;
                },
                inverse: function empty() {
                  return '';
                },
                root: root,
                parents: [ctx_2, ctx_1]
              });
              r += '</i>\n              </div>\n\n              <div class="margin-top">\n                ';
              r += c(ctx_3.comment, ctx_3);
              r += '\n              </div>\n              <hr>\n\n              ';
              r += Template7Helpers.if.call(ctx_3, ctx_3.reply_text, {
                hash: {},
                data: data_3 || {},
                fn: function (ctx_4, data_4) {
                  var r = '';
                  r += '\n              <h4>';
                  r += c(root.lng.replyOf, ctx_4);
                  r += ' ';
                  r += Template7Helpers.js.call(ctx_4, "new Date(this.reply_ts*1000).toLocaleString()", {
                    hash: {},
                    data: data_4 || {},
                    fn: function empty() {
                      return '';
                    },
                    inverse: function empty() {
                      return '';
                    },
                    root: root,
                    parents: [ctx_3, ctx_2, ctx_1]
                  });
                  r += ':</h4>\n              <div>';
                  r += c(ctx_4.reply_text, ctx_4);
                  r += '</div>\n              ';
                  return r;
                },
                inverse: function empty() {
                  return '';
                },
                root: root,
                parents: [ctx_2, ctx_1]
              });
              r += '\n\n              ';
              return r;
            },
            inverse: function empty() {
              return '';
            },
            root: root,
            parents: [ctx_1]
          });
          r += '\n              ';
          return r;
        },
        inverse: function empty() {
          return '';
        },
        root: root,
        parents: [ctx_1]
      });
      r += '\n\n              <div style="height: 120px;"></div>\n\n            </div>\n          </div>\n        </div>\n\n        <div class="fab fab-right-bottom booking-fab">\n          <a href="#">\n            <i class="icon f7-icons">plus</i>\n            <i class="icon f7-icons">xmark</i>\n          </a>\n          <div class="fab-buttons fab-buttons-left">\n            ';
      r += Template7Helpers.if.call(ctx_1, ctx_1.detail.annullable, {
        hash: {},
        data: data_1 || {},
        fn: function (ctx_2, data_2) {
          var r = '';
          r += '\n            <a href="#" @click="cancel(\'';
          r += c(ctx_2.detail.id, ctx_2);
          r += '\')" \n               class="bg-color-red text-color-white icon-only">\n              <i class="icon f7-icons">trash</i>\n            </a>\n            ';
          return r;
        },
        inverse: function empty() {
          return '';
        },
        root: root,
        parents: [ctx_1]
      });
      r += '\n\n            ';
      r += Template7Helpers.js_if.call(ctx_1, "this.detail.status == 0", {
        hash: {},
        data: data_1 || {},
        fn: function (ctx_2, data_2) {
          var r = '';
          r += '\n            <a href="#" @click="edit(\'';
          r += c(ctx_2.detail.id, ctx_2);
          r += '\')" \n               class="bg-color-blue text-color-white icon-only">\n              <i class="icon f7-icons">pencil</i>\n            </a>\n            ';
          return r;
        },
        inverse: function empty() {
          return '';
        },
        root: root,
        parents: [ctx_1]
      });
      r += '\n            <a href="/chat/';
      r += c(ctx_1.detail.poi.id, ctx_1);
      r += '/" \n               class="bg-color-primary text-color-imc popup-close">\n              <i class="icon f7-icons">chat_bubble_text_fill</i>\n            </a>\n\n            ';
      r += Template7Helpers.js_if.call(ctx_1, "this.detail.able_to_review", {
        hash: {},
        data: data_1 || {},
        fn: function (ctx_2, data_2) {
          var r = '';
          r += '\n            <a href="#" @click="writeReview(\'';
          r += c(ctx_2.detail.poi.id, ctx_2);
          r += '\')"\n               class="link popup-close bg-color-green fab-label-button">\n              <img width="22" src="static/check.png" alt=""/>\n              <span class="fab-label">';
          r += c(ctx_2.lng.writeReview, ctx_2);
          r += '</span>\n            </a>\n            ';
          return r;
        },
        inverse: function empty() {
          return '';
        },
        root: root,
        parents: [ctx_1]
      });
      r += '\n\n\n          </div>\n        </div>\n\n      </div>\n    </div> <!-- /.popup-detail -->\n\n\n    <div class="popup popup-edit popup-tablet-fullscreen" data-swipe-to-close="true">\n      <div class="view">\n        <div class="page">\n          <div class="navbar bg-color-imc">\n            <div class="navbar-bg bg-color-imc"></div>\n            <div class="navbar-inner bg-color-primary">\n              <div class="title center sliding">\n                <i class="icon f7-icons">pencil_circle_fill</i>\n                Edit\n              </div>\n              <div class="right">\n                <a class="link popup-close">\n                  <i class="icon f7-icons text-color-imc">multiply_circle_fill</i>\n                </a>\n              </div>\n            </div>\n          </div>\n          <div class="page-content bg-color-white">\n            <div class="list no-hairlines">\n              <ul>\n                <li class="item-content item-input">\n                  <div class="item-media">\n                    <img width="32" src="static/Cliente.png" alt=""/>\n                  </div>\n                  <div class="item-inner">\n                    <div class="item-input-wrap">\n                      <input type="text" \n                             disabled \n                             placeholder="';
      r += c(ctx_1.lng.clientCode, ctx_1);
      r += '" \n                             value="';
      r += c(ctx_1.me.client_code, ctx_1);
      r += '">\n                    </div>\n                  </div>\n                </li>\n                <li class="item-content item-input padding-top">\n                  <div class="item-media">\n                    <img width="32" src="static/Coperti.png" alt=""/>\n                  </div>\n                  <div class="item-inner">\n                    <div class="item-input-wrap">\n                      <input id="booking_edit_diners" \n                             type="tel" \n                             value="';
      r += c(ctx_1.detail.diners, ctx_1);
      r += '" \n                             placeholder="';
      r += c(ctx_1.lng.diners, ctx_1);
      r += '">\n                      <span class="input-clear-button"></span>\n                    </div>\n                  </div>\n                </li>\n                <li class="item-content item-input padding-top">\n                  <div class="item-media">\n                    <img width="32" src="static/DataOra.png" alt=""/>\n                  </div>\n                  <div class="item-inner">\n                    <div class="item-input-wrap">\n                      <input id="booking_edit_datetime" \n                             type="text" \n                             value="';
      r += Template7Helpers.js.call(ctx_1, "new Date(this.detail.ts*1000).toLocaleString()", {
        hash: {},
        data: data_1 || {},
        fn: function empty() {
          return '';
        },
        inverse: function empty() {
          return '';
        },
        root: root,
        parents: [ctx_1]
      });
      r += '" \n                             readonly="readonly" \n                             placeholder="';
      r += c(ctx_1.lng.dateAndTime, ctx_1);
      r += '">\n                    </div>\n                  </div>\n                </li>\n                <li class="item-content item-input padding-top">\n                  <div class="item-media"> \n                    <img class="md-only" style="position: absolute; top: 25px" width="32" src="static/Note.png" alt=""/>\n                    <img class="ios-only" width="32" src="static/Note.png" alt=""/>\n                  </div>\n                  <div class="item-inner">\n                    <div class="item-input-wrap">\n                      <textarea id="booking_edit_notes" \n                                placeholder="';
      r += c(ctx_1.lng.notes, ctx_1);
      r += '"\n                                value="';
      r += c(ctx_1.detail.notes, ctx_1);
      r += '"></textarea>\n                      <span class="input-clear-button"></span>\n                    </div>\n                  </div>\n                </li>\n                <li class="item-content item-input padding-top">\n                  <div class="item-media">\n                    <i class="f7-icons icon-rounded bg-color-imc text-color-primary">star_fill</i>\n                  </div>\n                  <div class="item-inner">\n                    <div class="item-input-wrap">\n                      <input disabled\n                             type="text" \n                             placeholder="';
      r += c(ctx_1.lng.promoCode, ctx_1);
      r += '" \n                             value="';
      r += c(ctx_1.detail.promo_code, ctx_1);
      r += '">\n                    </div>\n                  </div>\n                </li>\n              </ul>\n            </div>\n\n            <div class="padding" style="margin-top: 40px">\n              <a href="#" @click="editSave"\n                 class="button button-large button-fill button-round bg-imc text-color-white">\n                ';
      r += c(ctx_1.lng.edit, ctx_1);
      r += '\n                <img width="22" src="static/check.png" alt=""/></a>\n            </div>\n\n          </div>\n        </div>\n      </div>\n    </div><!-- /.popup-edit -->\n\n    <!-- Popup review -->\n    <div class="popup popup-write-review popup-tablet-fullscreen" data-swipe-to-close="true">\n      <div class="view">\n        <div class="page">\n          <div class="navbar bg-color-imc">\n            <div class="navbar-bg bg-color-imc"></div>\n            <div class="navbar-inner bg-color-primary">\n              <div class="title center sliding">\n                ';
      r += c(ctx_1.lng.writeReview, ctx_1);
      r += '\n              </div>\n              <div class="right">\n                <a class="link popup-close">\n                  <i class="icon f7-icons text-color-imc">multiply_circle_fill</i>\n                </a>\n              </div>\n            </div>\n          </div>\n          <div class="page-content">\n            <div class="block">\n\n              <div class="question">';
      r += Template7Helpers.js.call(ctx_1, "this.lng.question1.replace('$name$',this.detail.poi.caption)", {
        hash: {},
        data: data_1 || {},
        fn: function empty() {
          return '';
        },
        inverse: function empty() {
          return '';
        },
        root: root,
        parents: [ctx_1]
      });
      r += '</div>\n              <a href="#" @click="stars(\'general\',1)" class="general-1"><i class="f7-icons">star';
      r += Template7Helpers.js_if.call(ctx_1, "this.vote.stars > 0", {
        hash: {},
        data: data_1 || {},
        fn: function (ctx_2, data_2) {
          var r = '';
          r += '_fill';
          return r;
        },
        inverse: function empty() {
          return '';
        },
        root: root,
        parents: [ctx_1]
      });
      r += '</i></a>\n              <a href="#" @click="stars(\'general\',2)" class="general-2"><i class="f7-icons">star';
      r += Template7Helpers.js_if.call(ctx_1, "this.vote.stars > 1", {
        hash: {},
        data: data_1 || {},
        fn: function (ctx_2, data_2) {
          var r = '';
          r += '_fill';
          return r;
        },
        inverse: function empty() {
          return '';
        },
        root: root,
        parents: [ctx_1]
      });
      r += '</i></a>\n              <a href="#" @click="stars(\'general\',3)" class="general-3"><i class="f7-icons">star';
      r += Template7Helpers.js_if.call(ctx_1, "this.vote.stars > 2", {
        hash: {},
        data: data_1 || {},
        fn: function (ctx_2, data_2) {
          var r = '';
          r += '_fill';
          return r;
        },
        inverse: function empty() {
          return '';
        },
        root: root,
        parents: [ctx_1]
      });
      r += '</i></a>\n              <a href="#" @click="stars(\'general\',4)" class="general-4"><i class="f7-icons">star';
      r += Template7Helpers.js_if.call(ctx_1, "this.vote.stars > 3", {
        hash: {},
        data: data_1 || {},
        fn: function (ctx_2, data_2) {
          var r = '';
          r += '_fill';
          return r;
        },
        inverse: function empty() {
          return '';
        },
        root: root,
        parents: [ctx_1]
      });
      r += '</i></a>\n              <a href="#" @click="stars(\'general\',5)" class="general-5"><i class="f7-icons">star';
      r += Template7Helpers.js_if.call(ctx_1, "this.vote.stars > 4", {
        hash: {},
        data: data_1 || {},
        fn: function (ctx_2, data_2) {
          var r = '';
          r += '_fill';
          return r;
        },
        inverse: function empty() {
          return '';
        },
        root: root,
        parents: [ctx_1]
      });
      r += '</i></a>\n\n              <hr>\n\n              <div class="margin-top">\n                <div class="question">';
      r += c(ctx_1.lng.question2, ctx_1);
      r += '</div>\n                <div class="accordion-item">\n                  <div class="accordion-item-toggle">\n                    <i class="icon f7-icons plus">plus_circle</i>\n                    <span>Location</span>\n                  </div>\n                  <div class="accordion-item-content">\n                    <p>\n                      <a href="#" @click="stars(\'location\',1)" class="location-1"><i class="f7-icons">star';
      r += Template7Helpers.js_if.call(ctx_1, "this.vote.stars_location > 0", {
        hash: {},
        data: data_1 || {},
        fn: function (ctx_2, data_2) {
          var r = '';
          r += '_fill';
          return r;
        },
        inverse: function empty() {
          return '';
        },
        root: root,
        parents: [ctx_1]
      });
      r += '</i></a>\n                      <a href="#" @click="stars(\'location\',2)" class="location-2"><i class="f7-icons">star';
      r += Template7Helpers.js_if.call(ctx_1, "this.vote.stars_location > 1", {
        hash: {},
        data: data_1 || {},
        fn: function (ctx_2, data_2) {
          var r = '';
          r += '_fill';
          return r;
        },
        inverse: function empty() {
          return '';
        },
        root: root,
        parents: [ctx_1]
      });
      r += '</i></a>\n                      <a href="#" @click="stars(\'location\',3)" class="location-3"><i class="f7-icons">star';
      r += Template7Helpers.js_if.call(ctx_1, "this.vote.stars_location > 2", {
        hash: {},
        data: data_1 || {},
        fn: function (ctx_2, data_2) {
          var r = '';
          r += '_fill';
          return r;
        },
        inverse: function empty() {
          return '';
        },
        root: root,
        parents: [ctx_1]
      });
      r += '</i></a>\n                      <a href="#" @click="stars(\'location\',4)" class="location-4"><i class="f7-icons">star';
      r += Template7Helpers.js_if.call(ctx_1, "this.vote.stars_location > 3", {
        hash: {},
        data: data_1 || {},
        fn: function (ctx_2, data_2) {
          var r = '';
          r += '_fill';
          return r;
        },
        inverse: function empty() {
          return '';
        },
        root: root,
        parents: [ctx_1]
      });
      r += '</i></a>\n                      <a href="#" @click="stars(\'location\',5)" class="location-5"><i class="f7-icons">star';
      r += Template7Helpers.js_if.call(ctx_1, "this.vote.stars_location > 4", {
        hash: {},
        data: data_1 || {},
        fn: function (ctx_2, data_2) {
          var r = '';
          r += '_fill';
          return r;
        },
        inverse: function empty() {
          return '';
        },
        root: root,
        parents: [ctx_1]
      });
      r += '</i></a>\n                    </p>\n                  </div>\n                </div>\n                <div class="accordion-item">\n                  <div class="accordion-item-toggle">\n                    <i class="icon f7-icons plus">plus_circle</i>\n                    <span>Service</span>\n                  </div>\n                  <div class="accordion-item-content">\n                    <p>\n                      <a href="#" @click="stars(\'service\',1)" class="service-1"><i class="f7-icons">star';
      r += Template7Helpers.js_if.call(ctx_1, "this.vote.stars_service > 0", {
        hash: {},
        data: data_1 || {},
        fn: function (ctx_2, data_2) {
          var r = '';
          r += '_fill';
          return r;
        },
        inverse: function empty() {
          return '';
        },
        root: root,
        parents: [ctx_1]
      });
      r += '</i></a>\n                      <a href="#" @click="stars(\'service\',2)" class="service-2"><i class="f7-icons">star';
      r += Template7Helpers.js_if.call(ctx_1, "this.vote.stars_service > 1", {
        hash: {},
        data: data_1 || {},
        fn: function (ctx_2, data_2) {
          var r = '';
          r += '_fill';
          return r;
        },
        inverse: function empty() {
          return '';
        },
        root: root,
        parents: [ctx_1]
      });
      r += '</i></a>\n                      <a href="#" @click="stars(\'service\',3)" class="service-3"><i class="f7-icons">star';
      r += Template7Helpers.js_if.call(ctx_1, "this.vote.stars_service > 2", {
        hash: {},
        data: data_1 || {},
        fn: function (ctx_2, data_2) {
          var r = '';
          r += '_fill';
          return r;
        },
        inverse: function empty() {
          return '';
        },
        root: root,
        parents: [ctx_1]
      });
      r += '</i></a>\n                      <a href="#" @click="stars(\'service\',4)" class="service-4"><i class="f7-icons">star';
      r += Template7Helpers.js_if.call(ctx_1, "this.vote.stars_service > 3", {
        hash: {},
        data: data_1 || {},
        fn: function (ctx_2, data_2) {
          var r = '';
          r += '_fill';
          return r;
        },
        inverse: function empty() {
          return '';
        },
        root: root,
        parents: [ctx_1]
      });
      r += '</i></a>\n                      <a href="#" @click="stars(\'service\',5)" class="service-5"><i class="f7-icons">star';
      r += Template7Helpers.js_if.call(ctx_1, "this.vote.stars_service > 4", {
        hash: {},
        data: data_1 || {},
        fn: function (ctx_2, data_2) {
          var r = '';
          r += '_fill';
          return r;
        },
        inverse: function empty() {
          return '';
        },
        root: root,
        parents: [ctx_1]
      });
      r += '</i></a>\n                    </p>\n                  </div>\n                </div>\n                <div class="accordion-item">\n                  <div class="accordion-item-toggle">\n                    <i class="icon f7-icons plus">plus_circle</i>\n\n                    <span>Menu / Performance</span>\n                  </div>\n                  <div class="accordion-item-content">\n                    <p>\n                      <a href="#" @click="stars(\'menu\',1)" class="menu-1"><i class="f7-icons">star';
      r += Template7Helpers.js_if.call(ctx_1, "this.vote.stars_menu > 0", {
        hash: {},
        data: data_1 || {},
        fn: function (ctx_2, data_2) {
          var r = '';
          r += '_fill';
          return r;
        },
        inverse: function empty() {
          return '';
        },
        root: root,
        parents: [ctx_1]
      });
      r += '</i></a>\n                      <a href="#" @click="stars(\'menu\',2)" class="menu-2"><i class="f7-icons">star';
      r += Template7Helpers.js_if.call(ctx_1, "this.vote.stars_menu > 1", {
        hash: {},
        data: data_1 || {},
        fn: function (ctx_2, data_2) {
          var r = '';
          r += '_fill';
          return r;
        },
        inverse: function empty() {
          return '';
        },
        root: root,
        parents: [ctx_1]
      });
      r += '</i></a>\n                      <a href="#" @click="stars(\'menu\',3)" class="menu-3"><i class="f7-icons">star';
      r += Template7Helpers.js_if.call(ctx_1, "this.vote.stars_menu > 2", {
        hash: {},
        data: data_1 || {},
        fn: function (ctx_2, data_2) {
          var r = '';
          r += '_fill';
          return r;
        },
        inverse: function empty() {
          return '';
        },
        root: root,
        parents: [ctx_1]
      });
      r += '</i></a>\n                      <a href="#" @click="stars(\'menu\',4)" class="menu-4"><i class="f7-icons">star';
      r += Template7Helpers.js_if.call(ctx_1, "this.vote.stars_menu > 3", {
        hash: {},
        data: data_1 || {},
        fn: function (ctx_2, data_2) {
          var r = '';
          r += '_fill';
          return r;
        },
        inverse: function empty() {
          return '';
        },
        root: root,
        parents: [ctx_1]
      });
      r += '</i></a>\n                      <a href="#" @click="stars(\'menu\',5)" class="menu-5"><i class="f7-icons">star';
      r += Template7Helpers.js_if.call(ctx_1, "this.vote.stars_menu > 4", {
        hash: {},
        data: data_1 || {},
        fn: function (ctx_2, data_2) {
          var r = '';
          r += '_fill';
          return r;
        },
        inverse: function empty() {
          return '';
        },
        root: root,
        parents: [ctx_1]
      });
      r += '</i></a>\n                    </p>\n                  </div>\n                </div>\n                <div class="accordion-item">\n                  <div class="accordion-item-toggle">\n                    <i class="icon f7-icons plus">plus_circle</i>\n\n                    <span>';
      r += c(ctx_1.lng.price, ctx_1);
      r += '</span>\n                  </div>\n                  <div class="accordion-item-content">\n                    <p>\n                      <a href="#" @click="stars(\'price\',1)" class="price-1"><i class="f7-icons">star';
      r += Template7Helpers.js_if.call(ctx_1, "this.vote.stars_price > 0", {
        hash: {},
        data: data_1 || {},
        fn: function (ctx_2, data_2) {
          var r = '';
          r += '_fill';
          return r;
        },
        inverse: function empty() {
          return '';
        },
        root: root,
        parents: [ctx_1]
      });
      r += '</i></a>\n                      <a href="#" @click="stars(\'price\',2)" class="price-2"><i class="f7-icons">star';
      r += Template7Helpers.js_if.call(ctx_1, "this.vote.stars_price > 1", {
        hash: {},
        data: data_1 || {},
        fn: function (ctx_2, data_2) {
          var r = '';
          r += '_fill';
          return r;
        },
        inverse: function empty() {
          return '';
        },
        root: root,
        parents: [ctx_1]
      });
      r += '</i></a>\n                      <a href="#" @click="stars(\'price\',3)" class="price-3"><i class="f7-icons">star';
      r += Template7Helpers.js_if.call(ctx_1, "this.vote.stars_price > 2", {
        hash: {},
        data: data_1 || {},
        fn: function (ctx_2, data_2) {
          var r = '';
          r += '_fill';
          return r;
        },
        inverse: function empty() {
          return '';
        },
        root: root,
        parents: [ctx_1]
      });
      r += '</i></a>\n                      <a href="#" @click="stars(\'price\',4)" class="price-4"><i class="f7-icons">star';
      r += Template7Helpers.js_if.call(ctx_1, "this.vote.stars_price > 3", {
        hash: {},
        data: data_1 || {},
        fn: function (ctx_2, data_2) {
          var r = '';
          r += '_fill';
          return r;
        },
        inverse: function empty() {
          return '';
        },
        root: root,
        parents: [ctx_1]
      });
      r += '</i></a>\n                      <a href="#" @click="stars(\'price\',5)" class="price-5"><i class="f7-icons">star';
      r += Template7Helpers.js_if.call(ctx_1, "this.vote.stars_price > 4", {
        hash: {},
        data: data_1 || {},
        fn: function (ctx_2, data_2) {
          var r = '';
          r += '_fill';
          return r;
        },
        inverse: function empty() {
          return '';
        },
        root: root,
        parents: [ctx_1]
      });
      r += '</i></a>\n                    </p>\n                  </div>\n                </div>\n              </div>\n\n              <hr>\n\n              <div class="question margin-top">';
      r += c(ctx_1.lng.insertAComment, ctx_1);
      r += '</div>\n              <input id=\'review-title\' placeholder="';
      r += c(ctx_1.lng.insertATitle, ctx_1);
      r += '" value="';
      r += c(ctx_1.vote.title, ctx_1);
      r += '"/>\n              <textarea id="review-comment"\n                        value="';
      r += c(ctx_1.vote.comment, ctx_1);
      r += '"\n                        placeholder="';
      r += c(ctx_1.lng.insertAComment, ctx_1);
      r += '"></textarea>\n\n              <div class="margin-top"></div>\n              <button @click="saveReview" class="button button-large button-raised button-fill button-round">';
      r += c(ctx_1.lng.send, ctx_1);
      r += '</button>\n\n            </div>\n          </div>\n        </div>\n      </div>\n    </div> <!-- /.popup-write-review -->\n\n  </div> <!-- /page -->\n';
      return r;
    }(this);
  },

  styleScoped: false
};
    